import { jsx as e, jsxs as t } from "react/jsx-runtime";
import { useId as b, Children as x, isValidElement as $, cloneElement as v } from "react";
import { ErrorText as E } from "../ErrorText/ErrorText.js";
import { FormGroup as _ } from "../FormGroup/FormGroup.js";
import { HintText as F } from "../HintText/HintText.js";
import { LabelText as T } from "../LabelText/LabelText.js";
import { Stack as j } from "../Stack/Stack.js";
import { Stretch as I } from "../Stretch/Stretch.js";
const H = ({
  children: n,
  label: m,
  optional: c = !1,
  hint: i,
  error: l,
  fullWidth: p,
  characters: s = 25,
  affixWidth: f = 0,
  id: a,
  ...h
}) => {
  const u = b(), r = a || u, d = !!l;
  return /* @__PURE__ */ e(
    _,
    {
      "data-error": d || void 0,
      "data-testid": "nb-field-form-group",
      children: /* @__PURE__ */ t(j, { spaceBetween: 1, children: [
        /* @__PURE__ */ t("label", { id: `label_${r}`, htmlFor: r, children: [
          /* @__PURE__ */ t(T, { children: [
            m,
            c ? " (optional)" : null
          ] }),
          i ? /* @__PURE__ */ e(F, { children: i }) : null,
          /* @__PURE__ */ e("div", { id: `error_${r}`, role: "alert", children: l ? /* @__PURE__ */ e(E, { children: l }) : null })
        ] }),
        /* @__PURE__ */ e(
          I,
          {
            defaultWidth: `calc(${Math.ceil(
              s * 0.8
            )}em + ${f}px)`,
            fullWidth: p,
            children: x.map(
              n,
              (o) => $(o) ? v(o, {
                id: r,
                "aria-invalid": d || void 0,
                "aria-labelledby": `label_${r}`,
                ...h
              }) : o
            )
          }
        )
      ] })
    }
  );
};
export {
  H as Field
};
